import gql from 'graphql-tag';

import suggestionsPageFragment from '../fragments/suggestionsPageFragment';

export const querySuggestionsPage = gql`
  query suggestionsPage(
    $count: Int
    $offset: Int
    $suggestionTypes: [SuggestionType!]
    $dokkioLabelID: DokkioID
    $dokkioTagID: DokkioID
    $dokkioLabelName: String
    $dokkioTagName: String
    $integrationID: DokkioID
    $remoteID: String
    $webpageID: DokkioID
  ) {
    suggestionsPage(
      count: $count
      offset: $offset
      suggestionTypes: $suggestionTypes
      dokkioLabelID: $dokkioLabelID
      dokkioTagID: $dokkioTagID
      dokkioLabelName: $dokkioLabelName
      dokkioTagName: $dokkioTagName
      integrationID: $integrationID
      remoteID: $remoteID
      webpageID: $webpageID
    ) @connection(key: "suggestionsPage", filter: ["count", "offset", "suggestionType", "integrationID", "remoteID"]) {
      ...suggestionsPageFragment
    }
  }
  ${suggestionsPageFragment}
`;
export default querySuggestionsPage;
